import { FunctionComponent, memo } from "react";
import { IProps } from "./custom-reports-sidebar.types";
import { Sidebar, SidebarHeader } from "@edgetier/sidebar";
import CustomReportsList from "../custom-reports-list";
import "./custom-reports-sidebar.scss";

/**
 * A sidebar that lets users choose the report they want to view.
 */
const CustomReportsSidebar: FunctionComponent<IProps> = () => (
    <Sidebar className="custom-reports-sidebar">
        <SidebarHeader>
            <h2>Custom Reports</h2>
        </SidebarHeader>
        <CustomReportsList />
    </Sidebar>
);

export default memo(CustomReportsSidebar);
